import type {
  TIrrigationSchedulerStoreState,
  TIrrigationZoneEmitterWithCurrentEmitterStatus,
} from 'App/irrigation-scheduler/utils/store/irrigationSchedulerStore'
import { irrigationSchedulerStore } from 'App/irrigation-scheduler/utils/store/irrigationSchedulerStore'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'
import { fieldAssetStore } from 'stores/fieldAssetStore/fieldAssetStore'
import type { TValidIrrigationSchedulerZoneEmitterId } from 'stores/fieldAssetStore/helperTypes'
import { sortByKey } from 'utils/sortByKey'
import { sortByEmitterType } from '../../sortByEmitterType'
import { getValidIrrigationZoneEmittersForPropertyForIrrigationScheduler } from './getValidIrrigationZoneEmittersForPropertyForIrrigationScheduler'

export const getVisibleIrrigationZoneEmitters = (
  fass: TFieldAssetStoreState = fieldAssetStore.getState(),
  isss: TIrrigationSchedulerStoreState = irrigationSchedulerStore.getState(),
): TIrrigationZoneEmitterWithCurrentEmitterStatus[] => {
  const irrigationZoneEmitters = getValidIrrigationZoneEmittersForPropertyForIrrigationScheduler(fass, isss)

  const emitters = Object.entries(irrigationZoneEmitters).map(
    ([irrigationZoneEmitterId, irrigationZoneEmitter]) => {
      return {
        ...irrigationZoneEmitter,
        irrigationZoneEmitterId: irrigationZoneEmitterId as TValidIrrigationSchedulerZoneEmitterId,
        currentEmitterStatus:
          isss.currentEmitterStatus[irrigationZoneEmitterId as TValidIrrigationSchedulerZoneEmitterId],
      }
    },
  )

  const filteredEmitters =
    isss.selectedIrrigationZoneEmitterIds.length > 0
      ? emitters.filter((emitter) =>
          isss.selectedIrrigationZoneEmitterIds.includes(emitter.irrigationZoneEmitterId),
        )
      : emitters

  return filteredEmitters.sort(sortByEmitterType).sort(sortByKey('name'))
}
